import _implicitStylesheets from "./overview.css";
import _implicitScopedStylesheets from "./overview.scoped.css?scoped=true";
import _wdsHighlights from "wds/highlights";
import _wdsGridItem from "wds/gridItem";
import _listingProviderDetails from "listing/providerDetails";
import _listingPricing from "listing/pricing";
import _wdsButton from "wds/button";
import _wdsGrid from "wds/grid";
import _listingMoreFromThisProvider from "listing/moreFromThisProvider";
import _listingOtherAppsLikeThis from "listing/otherAppsLikeThis";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "wrapper": true
  },
  key: 0
};
const stc1 = {
  props: {
    "gridFlow": "wrap",
    "gridRowGap": "xxx-large"
  },
  key: 1
};
const stc2 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 2
};
const stc3 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 4
};
const stc4 = {
  props: {
    "gridFlow": "wrap",
    "gridGap": "x-large",
    "gridRowGap": "x-large"
  },
  key: 5
};
const stc5 = {
  props: {
    "gridItemSize": "1:1 1:2@large"
  },
  key: 6
};
const stc6 = {
  props: {
    "gridItemSize": "1:1 1:2@large"
  },
  key: 8
};
const stc7 = {
  "private-offer": true
};
const stc8 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 11
};
const stc9 = {
  key: 12
};
const stc10 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 14
};
const stc11 = {
  key: 15
};
const stc12 = {
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [api_custom_element("wds-grid", _wdsGrid, stc1, [$cmp.hasHighlights ? api_custom_element("wds-grid-item", _wdsGridItem, stc2, [api_custom_element("wds-highlights", _wdsHighlights, {
    props: {
      "highlights": $cmp.highlights,
      "highlightsLabel": $cmp.i18n.heading.highlights,
      "gridSize": "1:1 1:2@medium 1:3@large"
    },
    key: 3
  })]) : null, api_custom_element("wds-grid-item", _wdsGridItem, stc3, [api_custom_element("wds-grid", _wdsGrid, stc4, [api_custom_element("wds-grid-item", _wdsGridItem, stc5, [api_custom_element("listing-provider-details", _listingProviderDetails, {
    props: {
      "provider": $cmp.provider,
      "listing": $cmp.listing
    },
    key: 7
  })]), api_custom_element("wds-grid-item", _wdsGridItem, stc6, [api_custom_element("listing-pricing", _listingPricing, {
    props: {
      "pricing": $cmp.pricingPlan,
      "tabIndex": "0"
    },
    key: 9
  }), $cmp.showPrivateOffer ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc7,
    props: {
      "href": $cmp.privateOfferCtaHref,
      "label": $cmp.privateOfferCtaLabel,
      "name": "try it free"
    },
    key: 10
  }) : null])])]), api_custom_element("wds-grid-item", _wdsGridItem, stc8, [api_custom_element("wds-grid-item", _wdsGridItem, stc9, [api_custom_element("listing-more-from-this-provider", _listingMoreFromThisProvider, {
    props: {
      "providerName": $cmp.publisherName
    },
    key: 13
  })])]), api_custom_element("wds-grid-item", _wdsGridItem, stc10, [api_custom_element("wds-grid-item", _wdsGridItem, stc11, [api_custom_element("listing-other-apps-like-this", _listingOtherAppsLikeThis, stc12)])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-17m7nqf24h9";
tmpl.legacyStylesheetToken = "undefined-_overview";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
